import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/icon-v2.0.0'

export default reactNode(
	'Icon',
	{
		'v2.0.0': v200,
	},
	{ docs: '' }
)
